export default __webpack_public_path__ + "static/media/val10.3aa90c16.png";